module.exports = {"id":"193425","name":"Hanno Behrens","rating":"74","photo":"./data/images/photos/1/193425.png","club":{"name":"1. FC Nuremberg","logo":"./data/images/clubs/1.FCNuremberg.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HannoBehrens0.json
// module id = 1690
// module chunks = 0